import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import Outlet from "src/components/base/outlet";

/**
 * The properties for {@link GroupTabs}
 */
export type GroupTabsProps = {};

/**
 * Tabs for the device view
 */
function GroupTabs(props: GroupTabsProps) {
    const [t] = useTranslation("admin-groups");

    return (
        <TabLayout
            heading={t("heading.groups")}
            tabs={
                <TabMenu>
                    <Tab href={"/a/groups/local"}>{t("heading.local")}</Tab>
                    <Tab href={"/a/groups/ldap"}>{t("heading.ldap")}</Tab>
                    <Tab href={"/a/groups/scim"}>{t("heading.scim")}</Tab>
                </TabMenu>
            }
        >
            <Outlet />
        </TabLayout>
    );
}

export const Route = createFileRoute("/_admin/a/groups/_groups")({
    component: GroupTabs,
});
